import DatePicker from 'components/DatePickerStyled/DatePicker'
import Switch from 'components/Form/Switch'
import RichEditor from 'components/RichEditor'
import Select from 'components/Select'
import { SelectInputDiv } from 'components/UIComponents/FormStyles'
import {
  LabelWrapperText,
  SalaryFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/CompensationDetails/style'
import { FormItem } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import { TierInputNumber } from 'modules/Roles/NewRoleCreation/Partials/RolesForm/Partials/CtcJoblocation/Style/style'
import moment from 'moment'
import React, { useState } from 'react'

const TierPriceOption = [
  {
    id: 1,
    name: 'INR ₹',
    value: 'inr',
  },
]

const SalaryOptions = [
  {
    name: 'Per Annum',
    value: 'ANNUALLY',
  },
  {
    name: 'Per Month',
    value: 'MONTHLY',
  },
]

const CompensationDetails = ({
  dateFormat,
  onChangeSalary,
  form,
  singleRoleData,
}) => {
  const [bonus, setBonus] = useState(true)

  const disabledDate = current => {
    return current && current < moment()
  }

  return (
    <>
      <SalaryFlex>
        <FormItem ismargin>
          <LabelWrapperText>Salary</LabelWrapperText>
          <SelectInputDiv width="100%" borderleft={true}>
            <Select
              width="30%"
              OptionData={TierPriceOption}
              valueParam="value"
              bordered={false}
              defaultValue={singleRoleData?.CTC?.[0]?.currency}
              disabled={true}
            />
            <TierInputNumber
              width={'40vh'}
              height="48px"
              borderRadius={'0 8px 8px 0'}
              paddingTop={'7px'}
              name={'salary'}
              placeholder="Eg: 1,00,000"
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
              onChange={value =>
                onChangeSalary(
                  value > singleRoleData?.CTC?.[0]?.max
                    ? value
                    : singleRoleData?.CTC?.[0]?.max
                )
              }
            />
          </SelectInputDiv>
        </FormItem>

        <FormItem ismargin name={'frequency'}>
          <LabelWrapperText>Frequency</LabelWrapperText>
          <Select
            width="160px"
            OptionData={SalaryOptions}
            valueParam="value"
            bordered={false}
            defaultValue={singleRoleData?.CTCPeriod}
            onChange={value =>
              form.setFieldsValue({
                frequency: value,
              })
            }
            disabled={true}
          />
        </FormItem>
      </SalaryFlex>

      <FormItem name={'bouns'}>
        <Switch
          isImportant={true}
          label="Include Bouns"
          width={'30%'}
          checked={bonus}
          onChange={e => {
            form.setFieldsValue({
              bouns: e,
            })
            setBonus(e)
          }}
        />
      </FormItem>

      <FormItem>
        <LabelWrapperText>Offer Expire Date </LabelWrapperText>
        <DatePicker
          width="100%"
          placeholder={'Add Offer Expire Date'}
          dateFormat={dateFormat}
          name={'offerExpireDate'}
          disabledDate={disabledDate}
          rules={[
            {
              required: true,
              message: 'Please select offer expire date!',
            },
          ]}
        />
      </FormItem>
      <FormItem>
        <RichEditor
          labelName="Add Note"
          placeholder="Add Note"
          name={'note'}
          isImportant={true}
        />
      </FormItem>
    </>
  )
}

export default CompensationDetails
